import { optimizeImage } from '@utils/imageOptimization';

import {
  EitherRoomOrHotelFeaturesMeta,
  HotelFeaturesMeta,
  RoomFeaturesMeta,
} from '../components/details-galleries-modal/types';

export const getTypedFeatureProps = <
  DATA extends Pick<EitherRoomOrHotelFeaturesMeta, 'entityType' | 'features'>
>(
  data: DATA
) => {
  return data.entityType === 'hotel'
    ? (data as HotelFeaturesMeta)
    : (data as RoomFeaturesMeta);
};

export const cloudineryImage = (
  url: string,
  width?: number | string,
  height?: number | string,
  format = 'auto',
  quality = 'auto'
) => optimizeImage(url, width, height, { format, quality });
